import { render, staticRenderFns } from "./ProductPageTemplateModule.vue?vue&type=template&id=0b646670&"
import script from "./ProductPageTemplateModule.vue?vue&type=script&lang=js&"
export * from "./ProductPageTemplateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports